import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';

export interface VersionInfo {
  version: string;
}

@Component({
  selector: 'app-version',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './version.component.html',
})
export class VersionComponent implements OnInit {
  version = '';

  constructor(private http: HttpClient) {}

  ngOnInit(): void {
    this.http.get<VersionInfo>('assets/version.json').subscribe({
      next: data => {
        this.version = data.version;
      },
      error: () => {
        this.version = 'unknown';
      },
    });
  }
}
